// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TeamModal_TeamFragment = { __typename?: 'Team', id: string, name: string, workosDirectoryGroupID?: string | null, assignedHouseholds: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: { __typename?: 'Household', id: string } | null } | null> | null }, employees: { __typename?: 'EmployeeConnection', edges?: Array<{ __typename?: 'EmployeeEdge', node?: { __typename?: 'Employee', id: string } | null } | null> | null } };

export type TeamModalQueryVariables = Types.Exact<{
  teamId: Types.Scalars['ID']['input'];
}>;


export type TeamModalQuery = { __typename?: 'Query', teams: { __typename?: 'TeamConnection', edges?: Array<{ __typename?: 'TeamEdge', node?: (
        { __typename?: 'Team' }
        & TeamModal_TeamFragment
      ) | null } | null> | null } };

export type CreateTeamMutationVariables = Types.Exact<{
  input: Types.AugmentedCreateTeamInput;
}>;


export type CreateTeamMutation = { __typename?: 'Mutation', createTeam: (
    { __typename?: 'Team' }
    & TeamModal_TeamFragment
  ) };

export type UpdateTeamMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateTeamInput;
}>;


export type UpdateTeamMutation = { __typename?: 'Mutation', updateTeam: (
    { __typename?: 'Team' }
    & TeamModal_TeamFragment
  ) };

export const Operations = {
  Query: {
    TeamModal: 'TeamModal' as const
  },
  Mutation: {
    CreateTeam: 'CreateTeam' as const,
    UpdateTeam: 'UpdateTeam' as const
  },
  Fragment: {
    TeamModal_Team: 'TeamModal_Team' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const TeamModal_TeamFragmentDoc = gql`
    fragment TeamModal_Team on Team {
  id
  name
  workosDirectoryGroupID
  assignedHouseholds {
    edges {
      node {
        id
      }
    }
  }
  employees {
    edges {
      node {
        id
      }
    }
  }
}
    `;
export const TeamModalDocument = gql`
    query TeamModal($teamId: ID!) {
  teams(where: {id: $teamId}) {
    edges {
      node {
        ...TeamModal_Team
      }
    }
  }
}
    ${TeamModal_TeamFragmentDoc}`;

/**
 * __useTeamModalQuery__
 *
 * To run a query within a React component, call `useTeamModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamModalQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useTeamModalQuery(baseOptions: Apollo.QueryHookOptions<TeamModalQuery, TeamModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamModalQuery, TeamModalQueryVariables>(TeamModalDocument, withFetchPolicyContext(options));
      }
export function useTeamModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamModalQuery, TeamModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamModalQuery, TeamModalQueryVariables>(TeamModalDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useTeamModalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TeamModalQuery, TeamModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TeamModalQuery, TeamModalQueryVariables>(TeamModalDocument, withFetchPolicyContext(options));
        }
export type TeamModalQueryHookResult = ReturnType<typeof useTeamModalQuery>;
export type TeamModalLazyQueryHookResult = ReturnType<typeof useTeamModalLazyQuery>;
export type TeamModalSuspenseQueryHookResult = ReturnType<typeof useTeamModalSuspenseQuery>;
export type TeamModalQueryResult = Apollo.QueryResult<TeamModalQuery, TeamModalQueryVariables>;
export const CreateTeamDocument = gql`
    mutation CreateTeam($input: AugmentedCreateTeamInput!) {
  createTeam(input: $input) {
    ...TeamModal_Team
  }
}
    ${TeamModal_TeamFragmentDoc}`;
export type CreateTeamMutationFn = Apollo.MutationFunction<CreateTeamMutation, CreateTeamMutationVariables>;

/**
 * __useCreateTeamMutation__
 *
 * To run a mutation, you first call `useCreateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMutation, { data, loading, error }] = useCreateTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTeamMutation(baseOptions?: Apollo.MutationHookOptions<CreateTeamMutation, CreateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTeamMutation, CreateTeamMutationVariables>(CreateTeamDocument, options);
      }
export type CreateTeamMutationHookResult = ReturnType<typeof useCreateTeamMutation>;
export type CreateTeamMutationResult = Apollo.MutationResult<CreateTeamMutation>;
export type CreateTeamMutationOptions = Apollo.BaseMutationOptions<CreateTeamMutation, CreateTeamMutationVariables>;
export const UpdateTeamDocument = gql`
    mutation UpdateTeam($input: AugmentedUpdateTeamInput!) {
  updateTeam(input: $input) {
    ...TeamModal_Team
  }
}
    ${TeamModal_TeamFragmentDoc}`;
export type UpdateTeamMutationFn = Apollo.MutationFunction<UpdateTeamMutation, UpdateTeamMutationVariables>;

/**
 * __useUpdateTeamMutation__
 *
 * To run a mutation, you first call `useUpdateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamMutation, { data, loading, error }] = useUpdateTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamMutation, UpdateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeamMutation, UpdateTeamMutationVariables>(UpdateTeamDocument, options);
      }
export type UpdateTeamMutationHookResult = ReturnType<typeof useUpdateTeamMutation>;
export type UpdateTeamMutationResult = Apollo.MutationResult<UpdateTeamMutation>;
export type UpdateTeamMutationOptions = Apollo.BaseMutationOptions<UpdateTeamMutation, UpdateTeamMutationVariables>;